import { useState, useEffect, useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';

const WHATSAPP_NUM = '971547172715';

const defaultSlides = [
  {
    id: 1,
    tag: 'الوجهة الأولى لتجار العطور والتجميل',
    title: 'نجاحات لتجارة',
    highlight: 'العطور ومستحضرات التجميل',
    desc: 'وجهتك المثلى لأجود العطور الفاخرة ومستحضرات التجميل الأصيلة. شراكات تجارية ناجحة وتوصيل سريع لجميع دول الخليج.',
    image: 'https://public.readdy.ai/ai/img_res/8c218a04a88b509a12d8d23059241b23.jpg',
  },
  {
    id: 2,
    tag: 'أجود العطور العربية الأصيلة',
    title: 'عطور فاخرة',
    highlight: 'تدوم وتبقى',
    desc: 'مجموعة حصرية من أفخر العطور الشرقية في منظومة نجاحات لتجارة العطور ومستحضرات التجميل، مصنوعة بأيدي خبراء العطارة.',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20oud%20and%20amber%20perfume%20bottles%20dramatic%20dark%20studio%2C%20moody%20cinematic%20lighting%20with%20orange%20fire%20glow%2C%20deep%20shadows%20and%20rich%20textures%2C%20smoke%20and%20mist%20effects%2C%20luxury%20Arabic%20fragrance%20editorial%20photography%2C%20film-like%20color%20grading%20with%20deep%20blacks%20and%20warm%20amber%20highlights&width=1600&height=900&seq=cin_hero2&orientation=landscape',
  },
  {
    id: 3,
    tag: 'مستحضرات التجميل الفاخرة',
    title: 'جمال أصيل',
    highlight: 'بجودة عالمية',
    desc: 'أحدث مستحضرات التجميل والعناية بالبشرة من نجاحات لتجارة العطور ومستحضرات التجميل، تجمع بين الأصالة والجودة العالمية.',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20luxury%20beauty%20cosmetics%20dark%20dramatic%20scene%2C%20premium%20skincare%20products%20with%20moody%20spotlight%20lighting%2C%20deep%20black%20background%20with%20golden%20reflections%2C%20smoke%20and%20bokeh%20effects%2C%20high-end%20beauty%20editorial%20photography%20with%20film%20noir%20aesthetic%2C%20rich%20warm%20tones%20and%20deep%20shadows&width=1600&height=900&seq=cin_hero3&orientation=landscape',
  },
];

const stats = [
  { num: '+5000', label: 'عميل راضٍ' },
  { num: '+200', label: 'منتج فاخر' },
  { num: '24/7', label: 'دعم مستمر' },
];

const STORAGE_KEY = 'hero_slide_images';

function loadImages(): Record<number, string> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function saveImages(imgs: Record<number, string>) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(imgs));
}

export default function HeroSection() {
  const [active, setActive] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [slideImages, setSlideImages] = useState<Record<number, string>>(loadImages);
  const [savedMsg, setSavedMsg] = useState(false);
  const [editingSlideId, setEditingSlideId] = useState<number | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const goTo = useCallback((indexOrUpdater: number | ((prev: number) => number)) => {
    setAnimating(true);
    setTimeout(() => {
      setActive(prev =>
        typeof indexOrUpdater === 'function' ? indexOrUpdater(prev) : indexOrUpdater
      );
      setAnimating(false);
    }, 400);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      goTo(prev => (prev + 1) % defaultSlides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [goTo]);

  const getSlideImage = (slideId: number, fallback: string) =>
    slideImages[slideId] || fallback;

  const handleSlideImageClick = (slideId: number) => {
    if (!editMode) return;
    setEditingSlideId(slideId);
    fileInputRef.current?.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file || editingSlideId === null) return;
    const reader = new FileReader();
    reader.onload = ev => {
      const result = ev.target?.result as string;
      if (result) {
        const updated = { ...slideImages, [editingSlideId]: result };
        setSlideImages(updated);
        saveImages(updated);
        setSavedMsg(true);
        setTimeout(() => setSavedMsg(false), 2000);
      }
    };
    reader.readAsDataURL(file);
    e.target.value = '';
    setEditingSlideId(null);
  };

  const slide = defaultSlides[active];

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-black" dir="rtl">

      {/* Hidden File Input */}
      <input ref={fileInputRef} type="file" accept="image/*" className="hidden" onChange={handleFileChange} />

      {/* Saved Toast */}
      {savedMsg && (
        <div className="fixed top-6 left-1/2 -translate-x-1/2 z-[100] bg-[#E8721A] text-white text-sm font-bold px-6 py-3 flex items-center gap-2" style={{ clipPath: 'polygon(8px 0%, 100% 0%, calc(100% - 8px) 100%, 0% 100%)' }}>
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-check-line" />
          </div>
          تم تغيير الصورة بنجاح
        </div>
      )}

      {/* Background Slides */}
      {defaultSlides.map((s, i) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${i === active ? 'opacity-100' : 'opacity-0'}`}
        >
          <img
            src={getSlideImage(s.id, s.image)}
            alt=""
            className="w-full h-full object-cover object-top"
          />
          {/* Edit overlay per slide */}
          {editMode && i === active && (
            <button
              onClick={() => handleSlideImageClick(s.id)}
              className="absolute inset-0 flex flex-col items-center justify-center bg-black/40 cursor-pointer group/img z-10 transition-all hover:bg-black/60"
            >
              <div className="w-16 h-16 border-2 border-[#E8721A] flex items-center justify-center mb-3 group-hover/img:bg-[#E8721A] transition-colors">
                <i className="ri-camera-line text-white text-2xl" />
              </div>
              <span className="text-white font-bold text-sm tracking-widest uppercase bg-black/60 px-4 py-2">
                اضغط لتغيير صورة الخلفية
              </span>
            </button>
          )}
        </div>
      ))}

      {/* Cinematic overlays */}
      <div className="absolute inset-0 bg-gradient-to-l from-black/95 via-black/70 to-black/30 z-[5]" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/40 z-[5]" />

      {/* Cinematic letterbox bars */}
      <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-black to-transparent z-10" />
      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-black to-transparent z-10" />

      {/* Vertical light streak */}
      <div className="absolute right-1/3 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#E8721A]/20 to-transparent z-[5]" />

      {/* Edit Mode Toggle Button */}
      <button
        onClick={() => setEditMode(v => !v)}
        className={`absolute top-24 left-6 z-30 flex items-center gap-2 px-4 py-2 text-xs font-bold transition-all cursor-pointer whitespace-nowrap border ${
          editMode
            ? 'bg-[#E8721A] text-white border-[#E8721A]'
            : 'bg-black/50 text-white/60 border-white/20 hover:border-[#E8721A]/60 hover:text-[#E8721A]'
        }`}
        style={{ clipPath: 'polygon(6px 0%, 100% 0%, calc(100% - 6px) 100%, 0% 100%)' }}
      >
        <div className="w-4 h-4 flex items-center justify-center">
          <i className={editMode ? 'ri-check-double-line' : 'ri-image-edit-line'} />
        </div>
        {editMode ? 'إنهاء تعديل الصور' : 'تعديل صور الخلفية'}
      </button>

      {/* Edit Mode Hint */}
      {editMode && (
        <div className="absolute top-24 left-1/2 -translate-x-1/2 z-30 bg-black/70 border border-[#E8721A]/30 px-5 py-2 flex items-center gap-3 text-xs text-[#E8721A]/80">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-information-line" />
          </div>
          <span>اضغط على الخلفية لتغيير صورة الشريحة الحالية</span>
          <span className="text-white/30">|</span>
          <span>الشريحة {active + 1} من {defaultSlides.length}</span>
        </div>
      )}

      {/* Content */}
      <div className="relative z-20 w-full px-6 lg:px-24 py-32">
        <div className={`max-w-2xl mr-0 ml-auto lg:mr-0 text-right transition-all duration-500 ${animating ? 'opacity-0 translate-y-6' : 'opacity-100 translate-y-0'}`}>

          {/* Cinematic tag */}
          <div className="flex items-center gap-3 justify-end mb-8">
            <span className="text-[#E8721A]/80 text-xs font-bold tracking-[0.3em] uppercase">{slide.tag}</span>
            <div className="w-12 h-px bg-[#E8721A]/60" />
            <div className="w-2 h-2 rounded-full bg-[#E8721A] animate-pulse" />
          </div>

          {/* Title */}
          <h1 className="text-5xl lg:text-7xl font-black text-white leading-tight mb-6" style={{ fontFamily: "'Tajawal', sans-serif", textShadow: '0 0 60px rgba(232,114,26,0.3)' }}>
            <span className="block text-white/90">{slide.title}</span>
            <span className="block text-[#E8721A] relative mt-1">
              {slide.highlight}
            </span>
          </h1>

          {/* Divider line */}
          <div className="flex items-center gap-4 justify-end mb-6">
            <div className="h-px bg-gradient-to-l from-[#E8721A] to-transparent w-32" />
          </div>

          {/* Description */}
          <p className="text-white/60 text-base leading-relaxed mb-10 max-w-xl">
            {slide.desc}
          </p>

          {/* Buttons */}
          <div className="flex flex-wrap items-center gap-4 mb-6">
            <Link
              to="/products"
              className="flex items-center gap-3 bg-[#E8721A] text-white px-8 py-4 rounded-none text-sm font-bold hover:bg-[#C05A0A] transition-all duration-300 cursor-pointer whitespace-nowrap tracking-widest uppercase"
              style={{ clipPath: 'polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 12px 100%, 0 calc(100% - 12px))' }}
            >
              <span>تسوق الآن</span>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-left-line text-lg" />
              </div>
            </Link>
            <a
              href={`https://wa.me/${WHATSAPP_NUM}`}
              target="_blank"
              rel="nofollow noreferrer"
              className="flex items-center gap-3 border border-white/30 text-white px-8 py-4 rounded-none text-sm font-bold hover:border-[#E8721A] hover:text-[#E8721A] transition-all duration-300 cursor-pointer whitespace-nowrap tracking-widest uppercase"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line text-[#25D366] text-lg" />
              </div>
              <span>واتساب</span>
            </a>
          </div>

          {/* App Download Badges */}
          <div className="flex flex-wrap items-center gap-3 mb-12">
            <span className="text-white/30 text-xs font-medium whitespace-nowrap tracking-widest">حمّل تطبيقنا:</span>
            <a
              href="#"
              className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-[#E8721A]/40 rounded-lg px-4 py-2.5 transition-all duration-300 cursor-pointer group backdrop-blur-sm"
            >
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                <i className="ri-apple-fill text-white text-xl" />
              </div>
              <div>
                <div className="text-white/40 text-[9px] font-medium leading-none mb-0.5 whitespace-nowrap">Download on the</div>
                <div className="text-white font-black text-sm leading-none whitespace-nowrap">App Store</div>
              </div>
            </a>
            <a
              href="#"
              className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-[#E8721A]/40 rounded-lg px-4 py-2.5 transition-all duration-300 cursor-pointer group backdrop-blur-sm"
            >
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                <i className="ri-google-play-fill text-white text-lg" />
              </div>
              <div>
                <div className="text-white/40 text-[9px] font-medium leading-none mb-0.5 whitespace-nowrap">GET IT ON</div>
                <div className="text-white font-black text-sm leading-none whitespace-nowrap">Google Play</div>
              </div>
            </a>
          </div>

          {/* Stats */}
          <div className="flex items-center gap-10 border-t border-white/10 pt-8">
            {stats.map(stat => (
              <div key={stat.label} className="text-right">
                <div className="text-3xl font-black text-[#E8721A]" style={{ textShadow: '0 0 20px rgba(232,114,26,0.5)' }}>{stat.num}</div>
                <div className="text-white/40 text-xs tracking-widest uppercase">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Slide Controls */}
      <div className="absolute bottom-24 left-1/2 -translate-x-1/2 flex items-center gap-2 z-20">
        {defaultSlides.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className={`rounded-none transition-all duration-500 cursor-pointer ${
              i === active ? 'w-10 h-0.5 bg-[#E8721A]' : 'w-4 h-0.5 bg-white/30 hover:bg-white/60'
            }`}
          />
        ))}
      </div>

      {/* Slide arrows */}
      <button
        onClick={() => goTo((active - 1 + defaultSlides.length) % defaultSlides.length)}
        className="absolute left-6 top-1/2 -translate-y-1/2 z-20 w-10 h-10 flex items-center justify-center border border-white/20 bg-black/30 text-white hover:bg-[#E8721A] hover:border-[#E8721A] transition-all duration-300 cursor-pointer"
      >
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-left-s-line text-lg" />
        </div>
      </button>
      <button
        onClick={() => goTo((active + 1) % defaultSlides.length)}
        className="absolute right-6 top-1/2 -translate-y-1/2 z-20 w-10 h-10 flex items-center justify-center border border-white/20 bg-black/30 text-white hover:bg-[#E8721A] hover:border-[#E8721A] transition-all duration-300 cursor-pointer"
      >
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-right-s-line text-lg" />
        </div>
      </button>

      {/* Slide number — cinematic style */}
      <div className="absolute top-1/2 left-8 -translate-y-1/2 z-20 hidden lg:flex flex-col items-center gap-2">
        <span className="text-[#E8721A] text-2xl font-black" style={{ fontFamily: 'monospace' }}>0{active + 1}</span>
        <div className="w-px h-16 bg-white/10" />
        <span className="text-white/20 text-xs" style={{ fontFamily: 'monospace' }}>0{defaultSlides.length}</span>
      </div>
    </section>
  );
}
